// extracted by mini-css-extract-plugin
export default {"providerListTitle":"ProviderList_providerListTitle__594Ae","providersTable":"ProviderList_providersTable__Uhlje","actionButton":"ProviderList_actionButton__5tYKT"};